<h5 class="zint-card-title max-width-85">{{ label }}</h5>
@if(!renderData.length) {
<div class="aira-nodata-icon-backdrop">
    <i class="fa-duotone fa-thin fa-list-check"></i>
    <p>No insights have been derived.</p>
</div>
}
@else {
    <div class="pill-container" [ngClass]="{'blur-content': previewOnly}">
        @for (item of pillsToRender; track $index) {

            @if(renderTextPropertyName){
                <span matTooltipPosition="above" matTooltip="{{item[onHoverPropertyName]}}">&check; {{ item[renderTextPropertyName] }}</span>
            }
            @else {
                <span>&check; {{ item }}</span>
            }
            
        }
        @if (leftoverCount) {
        <span role="button" class="badge-vivid-blue" (click)="showAllPills()">{{leftoverCount}}+</span>
        }
    </div>
}
